import globalStyles from '@/styles/index.module.css';
import Badge from '@nautilusbio/nb-design-system/Badge';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import Table from '@nautilusbio/nb-design-system/Table';
import { Text } from '@nautilusbio/nb-design-system/Text';
import type { AgGridReact } from 'ag-grid-react';
import clsx from 'clsx';
import type { RefObject } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useSampleColDefs } from '../helpers';
import irStyles from '../styles.module.css';
import { Sample } from '../types';

interface Props {
  id: string;
  samples: Sample[];
  numSamples?: number | undefined | null;
  gridRef: RefObject<AgGridReact<Sample> | null>;
}

const RunSamplesList = ({ id, samples, numSamples, gridRef }: Props) => {
  const { t } = useTranslation('runs', { keyPrefix: 'header' });
  const sampleColDefs = useSampleColDefs();

  return (
    <Stack className={irStyles.samplesTableContainer} fullHeight fullWidth gap={4} orientation="vertical">
      <Stack gap={4} orientation="horizontal">
        <Text as="h3">{t('samples')}</Text>

        <Badge size="sm" variant="info">
          {numSamples}
        </Badge>
      </Stack>

      <Stack className={clsx(irStyles.samplesTable, globalStyles.scrollbars)} fullHeight fullWidth>
        <Table
          tableId={`${id}-samples-table`}
          columnDefs={sampleColDefs}
          domLayout={samples?.length > 12 ? 'normal' : 'autoHeight'}
          enableAdvancedFilter={false}
          enableResponsiveResize={true}
          ref={gridRef}
          resizeDebounceMs={150}
          rowData={samples}
        />
      </Stack>
    </Stack>
  );
};

export default RunSamplesList;
